export const API_PROJECTS_DESCRIPTION_METRICS_FIELDS = [
    'metrics.project_description_metrics_id'
];
